import { Form } from "react-final-form";

import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import { onSubmit, onValidate } from "./SecretResourceFormSubmit";
import SecretResourceFormStepOne from "../SecretResourceFormSteps/SecretResourceFormStepOne";
// import SecretFormStepOne from "./SecretFormSteps/SecretFormStepOne";

const SecretResourceForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, { ...props, initialValues })}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <>
            <form
              id={props.formName}
              onSubmit={formProps.handleSubmit}
              className="SecretResourceForm"
            >
              <SwipeableViews
                axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                index={step}
                onChangeIndex={(index) => setStep(index)}
              >
                <SecretResourceFormStepOne {...formProps} {...props} />
              </SwipeableViews>
            </form>
          </>
        );
      }}
    </Form>
  );
};

export default SecretResourceForm;
